import { injectTranslate } from '@core/i18n-legacy';
import { tagsCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const tagsColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Tags,
  label: injectTranslate()('app.offers.table.tags'),
  visible: true,
  geometry: {
    width: 200,
    minWidth: 100,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: tagsCellFactory('offerTags', { isHoverable: false, disabled: true }),
}));
